import { ArrowNavDownIcon } from "@bookingcom/bui-assets-react/streamline";
import { Button, type ButtonProps } from "@bookingcom/bui-react";
import { formatDateRange } from "../../../utils/date";
import type { DateRange } from "../../../types/date";
import styles from "../DateRangePicker.module.css";

type DateRangePickerTriggerProps = {
  dateRange: DateRange;
} & Pick<ButtonProps, "attributes">;

export const DateRangePickerTrigger = ({
  dateRange: { startDate, endDate },
  attributes,
}: DateRangePickerTriggerProps) => {
  return (
    <Button
      variant="secondary-neutral"
      icon={ArrowNavDownIcon}
      iconPosition="end"
      ariaLabel="Select date range"
      className={styles.popoverTrigger}
      attributes={attributes}
    >
      {formatDateRange(startDate, endDate)}
    </Button>
  );
};
